import DemenagementStepsPopin from "./fragments/DemenagementStepsPopin.vue";
import DemenagementHomeServicesPush from "./fragments/DemenagementHomeServicesPush.vue";

window.app = new Vue({
    el: "#internet-demenagement-home",
    name: "InternetDemenagementHome",
    components: {
        DemenagementStepsPopin,
        DemenagementHomeServicesPush
    },
    data: {
        pageVue: pageDto,
        defaultExpandedStepIndex: -1
    },
    methods: {
        openPopinWithDemStepIndex(event) {
            const index = parseInt(event.target.getAttribute('data-expanded-step-index'), 10);

            this.defaultExpandedStepIndex = -1;
            this.$nextTick(() => {
                this.defaultExpandedStepIndex = index;
            });
        }
    }
});
